var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-carousel'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container culture-content"},[_c('img',{staticClass:"img-responsive",attrs:{"src":require("../../../../assets/img/culture/cal.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }